import {
  CONDITION,
  type Conditions,
  type Item,
  PROMOTION_TYPE,
  Restrictions,
} from 'typings'
import { SCOPE_OPTIONS } from '../Form/ItemsView/typing'
import type { PromotionBase } from './promotion'

export type MoreForLessConditions = Pick<
  Conditions,
  | CONDITION.BIN
  | CONDITION.CLUSTER
  | CONDITION.ORDER_VALUE
  | CONDITION.PAYMENT_METHODS
  | CONDITION.UTM
  | CONDITION.LIST_PRICE
>

export enum MoreForLessBenefitVariant {
  PERCENTUAL = 'percentual',
  MAX_PRICE_PER_ITEM = 'maxPricePerItem',
}

export enum MoreForLess {
  Trigger = 'trigger',
  Benefit = 'benefit',
}

export type MoreForLessDiscount =
  | {
      type: MoreForLessBenefitVariant.PERCENTUAL
      value: number | undefined
    }
  | {
      type: MoreForLessBenefitVariant.MAX_PRICE_PER_ITEM
      value: number | undefined
    }

export type MoreForLessTrigger = {
  [SCOPE_OPTIONS.SKUS]: Item[]
  [SCOPE_OPTIONS.COLLECTIONS]: Item[]
  minQuantity: number
}

export type MoreForLessBenefit = {
  quantity: number
  discount: MoreForLessDiscount
  apply: {
    equals: boolean
    mostExpensive: boolean
    distributed: boolean
  }
}

export interface MoreForLessEffect {
  [MoreForLess.Trigger]: MoreForLessTrigger | undefined
  [MoreForLess.Benefit]: MoreForLessBenefit | undefined
}

export type MoreForLessRestrictions = Omit<Restrictions, 'maxItemsPerAttribute'>

export interface MoreForLessPromotion extends PromotionBase {
  type: PROMOTION_TYPE.MORE_FOR_LESS
  moreForLess: MoreForLessEffect
  conditions: MoreForLessConditions
  restrictions: MoreForLessRestrictions
}
